import {AppContext} from "../app-context";
import {CanActivateFn, ActivatedRouteSnapshot, UrlTree} from '@angular/router';

export const newRouteGuard: CanActivateFn = (route: ActivatedRouteSnapshot): boolean | UrlTree => {
  AppContext.isNewRoute = true;
  AppContext.routeData = route.routeConfig?.data;
  $(window.document.body).addClass("new-portvisit");
  return true;
};
